/* NECES form submission logger (Agora Studio)
   Beacons every contact-form submission to a Google Sheet for tracking.
   ENDPOINT: set to the deployed Apps Script web app URL. Empty = disabled. */
(function(){
  var ENDPOINT = ''; // <- Apps Script /exec URL goes here

  if(!ENDPOINT) return;

  function fieldVal(form, names){
    for(var i = 0; i < names.length; i++){
      var el = form.querySelector('[name="contact[' + names[i] + ']"]');
      if(el && el.value) return el.value;
    }
    return '';
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.action || form.action.indexOf('/contact') === -1) return;

    // Quote forms are logged by the backend + draft orders — skip to avoid double-logging
    if(form.classList.contains('nc-quote-form')) return;

    try {
      var payload = {
        form: form.id || 'Contact Form',
        page: window.location.pathname,
        name: fieldVal(form, ['name', 'Name']),
        email: fieldVal(form, ['email', 'Email']),
        phone: fieldVal(form, ['phone', 'Phone']),
        business: fieldVal(form, ['Business Name', 'business']),
        subject: fieldVal(form, ['Subject', 'subject']),
        body: fieldVal(form, ['Products Requested', 'body', 'Body']),
        notes: fieldVal(form, ['Notes', 'notes']),
        itemCount: ''
      };
      var blob = new Blob([JSON.stringify(payload)], {type: 'text/plain'});
      navigator.sendBeacon(ENDPOINT, blob);
    } catch(err){ /* never block the real submission */ }
  }, true);
})();
